import { render, staticRenderFns } from "./p15.vue?vue&type=template&id=0bb0223c&scoped=true&"
import script from "./p15.vue?vue&type=script&lang=js&"
export * from "./p15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb0223c",
  null
  
)

export default component.exports